export default __webpack_public_path__ + "static/media/cloud.4a4ae3a1.png";